import {
  withTranslation,
} from 'react-i18next';

import SocialAuthButtonsView from './SocialAuthButtonsView';

const TranslatedComponent = withTranslation()(SocialAuthButtonsView);

const Component = TranslatedComponent;

export default Component;
